import reactImage from '../assets/logos/react.svg';
import photoshopImage from '../assets/logos/adobe-photoshop-cc.svg';
import css3Image from '../assets/logos/css3.svg';
import firebaseImage from '../assets/logos/firebase.svg';
import supabaseImage from '../assets/logos/supabase.svg';
import htmlImage from '../assets/logos/html5.svg';
import javascriptImage from '../assets/logos/javascript-js.svg';
import expoImage from '../assets/logos/expo.svg';
import javaImage from '../assets/logos/java.png';
// import jsonImage from '../assets/logos/json.svg';
import nodejsImage from '../assets/logos/nodejs.svg';
// import npmImage from '../assets/logos/npm-node-package-manager.svg';
import phpImage from '../assets/logos/php.svg';
import reactNativeImage from '../assets/logos/react-native.svg';
import pythonImage from '../assets/logos/python.svg';
import wixImage from '../assets/logos/wix.svg'
import iosImage from '../assets/logos/apple-ios.svg'
import googlePlayImage from '../assets/logos/google-playstore.svg'
import youtubeImage from '../assets/logos/youtube.svg'
import mysqlImage from '../assets/logos/mysql.svg'
import djangoImage from '../assets/logos/django.svg'
import androidStudioImage from '../assets/logos/android_studio.png'
import xcodeImage from '../assets/logos/xcode.png'
import unityImage from '../assets/logos/unity.svg'
import googleCloudImage from '../assets/logos/google_cloud.svg'
import gitHubImage from '../assets/logos/github.png'
import shopifyImage from '../assets/logos/shopify.png'
import figmaImage from '../assets/logos/figma.png'
import typescriptImage from '../assets/logos/typescript.webp'
import tailwindImage from '../assets/logos/tailwind-css.png'
import amplitudeImage from '../assets/logos/amplitude.png'
import sentryImage from '../assets/logos/sentry.png'
import codexImage from '../assets/logos/codex.svg'


export const main_skills = [
    {
        logo: typescriptImage,
        description: 'TypeScript',
        color: 'blue'
    },
    {
        logo: javascriptImage,
        description: 'JavaScript',
        color: 'yellow'
    },
    {
        logo: reactNativeImage,
        description: 'React Native',
        color: 'blue'
    },
    {
        logo: supabaseImage,
        description: 'Supabase',
        color: 'green'
    },
    {
        logo: pythonImage,
        description: 'Python',
        color: 'yellow'
    },
    {
        logo: expoImage,
        description: 'Expo',
        color: 'blue'
    },
    {
        logo: reactImage,
        description: 'React',
        color: 'blue'
    },
    {
        logo: codexImage,
        description: 'AI-assisted development and code review with Codex'
    },

]

export const secondary_skills = [

    {
        logo: css3Image,
        description: 'CSS 3',
        color: 'blue'

    },
    {
        logo: firebaseImage,
        description: 'Firebase',
        color: 'yellow'
    },
    {
        logo: htmlImage,
        description: 'HTML 5',
        color: 'orange'
    },
    {
        logo: iosImage,
        description: 'App Store Connect'
    },
    {
        logo: googlePlayImage,
        description: 'Google Play Store'
    },
    {
        logo: photoshopImage,
        description: 'Photoshop CC'
    },
    {
        logo: gitHubImage,
        description: 'GitHub'
    },
    {
        logo: tailwindImage,
        description: 'Tailwind CSS',
        color: 'blue'
    },
    {
        logo: mysqlImage,
        description: 'MySQL'
    },
    {
        logo: youtubeImage,
        description: 'Youtube'
    },
    {
        logo: wixImage,
        description: 'Wix'
    },

    {
        logo: phpImage,
        description: 'PHP'
    },
    {
        logo: djangoImage,
        description: 'Django'
    },
    {
        logo: xcodeImage,
        description: 'Xcode'
    },
    {
        logo: unityImage,
        description: 'Unity'
    },
    {
        logo: androidStudioImage,
        description: 'Android Studio'
    },
    {
        logo: shopifyImage,
        description: 'Shopify'
    },
    {
        logo: googleCloudImage,
        description: 'Google Cloud Platform'
    },
    {
        logo: javaImage,
        description: 'Java'
    },
    {
        logo: nodejsImage,
        description: 'Node.js'
    },
    {
        logo: figmaImage,
        description: 'Figma'
    },
    {
        logo: sentryImage,
        description: 'Sentry'
    },
    {
        logo: amplitudeImage,
        description: 'Amplitude'
    },
    {
        shortLabel: 'MCP',
        description: 'Model Context Protocol tools'
    }
]
